module.exports = __webpack_public_path__ + "static/img/UTSG老师_Dylan.9eedbc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG老师_Dylan.png
// module id = zuXr
// module chunks = 0